export class GetWorkItemSaRequest {
    LOB: string = 'OL';
    assignmentid: string|number = 0;
    uuid: string = '';
}
